<template>
  <div>
    <p>Redirecting to app...</p>
  </div>
</template>

<script>
export default {
  name: "OpenMobileApp",
  data() {
    return {
      appRedirecting: false,
      userId: 123,
      fallbackTimeout: 1500 // milliseconds
    };
  },
  created() {
    this.userId = this.$route.query.userId;
    // this.redirectToApp();
  },
  methods: {
    redirectToApp() {
      this.appRedirecting = true;
      const appLink = `bagdaily://openapp?nip=${this.userId}`;

      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = appLink;
      document.body.appendChild(iframe);
    }
  }
};
</script>
